<template>
    <div v-if="stage" class="px-4">
        <v-row>
            <v-col>
                <v-card-text class="ml-0 pa-0 ma-0">
                    <label> Ubicación a eliminar: </label>
                </v-card-text>
                <RouteInBagSelectorComponent
                    v-model="stage.payload_location"
                    :my_bag="my_bag"
                    :allow_hardcoding="false"
                    outlined></RouteInBagSelectorComponent>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-alert dense outlined type="info" class="text-caption">
                    Esta etapa elimina instancias o datos del contexto:
                    <ul class="mt-2">
                        <li>Si es una instancia en context_data o hidden_context_data, la eliminará</li>
                        <li>Si es una lista de instancias, eliminará todas</li>
                        <li>Si es un campo nested (ej: "persona.direccion"), eliminará ese campo</li>
                        <li>Si es raw_context_data, lo pondrá a null</li>
                    </ul>
                </v-alert>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import { DeleteContextInstance } from '@/modules/document/domain/WorkflowTemplate';
import { DOCS_FIELD_MAP_SHOW } from "@/modules/document/domain/Document";
import RouteInBagSelectorComponent from '@/modules/document/infra/RouteInBagSelectorComponent';

export default {
    name:'DeleteContextInstanceDetailComponent',
    components: {
        RouteInBagSelectorComponent,
    },
    props:{
        stage: {
            type: DeleteContextInstance,
            default: false,
        },
        showErrors: {
            type: Boolean,
            default: false
        },
        my_bag:{
            type: Object,
            required: false,
            default: () => {}
        }
    },
    data(){
        return {
            cssLink: null,
            selected_schema: null
        }
    },
    mounted(){
        console.log(this.stage);
    },
    methods:{
        formatField(field) {
            return DOCS_FIELD_MAP_SHOW[field] || field;
        },

        computeStage(){
            this.$emit('compute-stage');
        }
    },
    computed:{

    },
    beforeDestroy() {
    }
}
</script>

<style scoped >
.preaty__card {
    border-radius: 5px;
}
.small_scrollbar >>> textarea {
    scrollbar-width: thin;
}
.error--text {
    color: rgba(220, 11, 11, 0.898) !important;
}
</style>
